import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { emptyInstructionPhone } from "./CountryPhone";
import { AddBranch } from "./AddBranch";
import { Branch } from "../../../../../../../Wrap/Models/Models/Company/Branch";

interface IBranchesProps extends React.Props<Branches> {
    isReview?: boolean;
    data: FirmInstruction;
    onChange: (changes) => void;
    onRef: (ref) => void;
}

interface IBranchesState {
    isEdit: number;
    currentBranch: Branch;
}

export class Branches extends FormComponent<IBranchesProps, IBranchesState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isEdit: null,
            currentBranch: null,
        };
    }

    private emptyBranch(): Branch {
        return {
            BranchName: null,
            Email: { Value: null },
            ContainsSensitiveAccounts: false,
            PhoneNumber: emptyInstructionPhone,
            FaxNumber: emptyInstructionPhone,
            UseFirmAddress: false,
            BranchAddress: {
                Postcode: null,
                Line1: null,
                Line2: null,
                Line3: null,
                Line4: null,
            },
        };
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    private onBranchChange(changes) {
        const { currentBranch } = this.state;

        for (const key in changes) {
            currentBranch[key] = changes[key];
        }

        this.setState({ currentBranch });
    }

    private onAddBranch() {
        const { Branches } = this.props.data;
        const { currentBranch, isEdit } = this.state;
        let _branches = Branches.concat([]);
        if (isEdit == 0 || isEdit) {
            _branches[isEdit] = currentBranch;
        } else {
            _branches = _branches.concat(currentBranch);
        }

        this.setState({ isEdit: null, currentBranch: null });
        this.props.onChange({ Branches: _branches });
    }

    private onDeleteBranch(index) {
        const { Branches } = this.props.data;
        Branches.splice(index, 1);
        if (this.state.isEdit == index) {
            this.setState({ isEdit: null, currentBranch: null });
        }
        this.props.onChange({ Branches });
    }

    render() {
        const { data } = this.props;
        const { isEdit, currentBranch } = this.state;
        return (
            <>
                {SectionHeader("Branches")}

                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Branch name</th>
                            <th>
                                <button
                                    disabled={this.props.isReview}
                                    className="btn primary"
                                    onClick={() => this.setState({ isEdit: null, currentBranch: this.emptyBranch() })}
                                >
                                    Add branch
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.Branches.map((branch, index) => {
                            return (
                                <tr key={`branch-${index}`}>
                                    <td>{branch.BranchName}</td>
                                    <td>
                                        <button
                                            className="btn secondary mr-5"
                                            onClick={() =>
                                                this.setState({
                                                    isEdit: index,
                                                    currentBranch: JSON.parse(JSON.stringify(branch)),
                                                })
                                            }
                                        >
                                            {this.props.isReview ? "View" : "Edit"}
                                        </button>
                                        <button
                                            className="btn secondary"
                                            disabled={this.props.isReview}
                                            onClick={() => this.onDeleteBranch(index)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {currentBranch && (
                    <AddBranch
                        currentFirm={data}
                        isReview={this.props.isReview}
                        onClickSave={() => this.onAddBranch()}
                        onClickCancel={() => this.setState({ isEdit: null, currentBranch: null })}
                        data={currentBranch}
                        onChange={(changes) => this.onBranchChange(changes)}
                    />
                )}
            </>
        );
    }
}
